import { Injectable } from '@angular/core';
import { GeneralHttpService } from 'src/app/shared/general-http.service';
import { Ciudad } from './ciudad.model';

@Injectable({
  providedIn: 'root'
})
export class CiudadesServiceService {

  private url = "AdmCiudads";

  listCitys: Ciudad[];

  constructor(private generalHttp:GeneralHttpService) { }

  getCitys(){
    return this.generalHttp.getHttp<Ciudad>("AdmCiudads").then(c => this.listCitys = c as Ciudad[])
  }

  getCiudadById(idCiudad){
    return this.generalHttp.getHttpById(idCiudad,`${this.url}`);
  }

  getCitys2(){
    return this.generalHttp.getHttp("AdmCiudads");
  }

  updateCities(){
    return this.generalHttp.getHttpById<string>("go","AdmCiudads");
  }

  getCitiesSearch(name: string) {
    return this.generalHttp.getHttpById(name,`${this.url}/GetCiudadSearch`);
  }

  GetCities() {
    return this.generalHttp.getHttp(`${this.url}/GetCities`);
  }
}
